import {
  IconWrapper,
  IStyles,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import { useGlobalContext } from 'apps/teacher/src/app/Context/GlobalContextProvider';

const styles: IStyles = {
  iconBox: {
    width: { xs: '100%', md: '100%', lg: '100%' },
    backgroundColor: '#FFFFFF',
    borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: { xs: pxToRem(20), md: pxTovW(30) },
    boxSizing: 'border-box',
    border: { md: '1px solid #E0DFDE' },
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxToRem(10),
    boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
    // marginLeft: { xs: pxToRem(0), md: pxTovW(40), lg: pxTovW(40) },
    paddingX: { xs: pxToRem(12), md: pxTovW(20) },
    paddingY: { xs: pxToRem(20), md: pxTovW(20) },
  },

  heading: {
    // width: '100%',
    // boxSizing: 'border-box',
    // display: 'flex',
    // gap: { xs: pxToRem(20), md: pxTovW(30) },
    // justifyContent: 'space-between',
    // alignItems: 'center',
    // paddingX: { xs: pxToRem(20), md: pxTovW(26) },
    // mt: { xs: pxToRem(12), md: 0 },
    marginRight: 'auto',
  },
};

interface IOmrIconDetailsProps {
  totalQuestions: number;
  totalMarks: number;
  difficulty: string;
}

export const OmrIconDetails = (props: IOmrIconDetailsProps) => {
  const { totalQuestions, totalMarks, difficulty } = props;
  const { isIpadOnly } = useGlobalContext();
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box sx={styles.iconBox}>
      <Box sx={styles.heading}>
        <Typography variant="h2" fontWeight="bold" textAlign="left">
          Test Overview
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-around',
          paddingY: { xs: pxToRem(10), md: 0 },
          gap: { xs: pxToRem(10), md: pxTovW(20) },
          boxSizing: 'border-box',
          alignItems: 'center',
          overflowX: { xs: 'auto', md: 'visible' },
          overflowY: 'hidden',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <IconBox
          iconName="questions"
          primaryText={totalQuestions}
          secondaryText="Questions"
          divider={true}
        />

        <IconBox
          iconName="bar-graph"
          primaryText={difficulty}
          secondaryText="Difficulty"
          divider={true}
        />

        <IconBox
          iconName="percentage-primary"
          primaryText={totalMarks}
          secondaryText="Total Marks"
        />
      </Box>
    </Box>
  );
};

//=====================================================

interface IIconBoxProps {
  iconName: string;
  primaryText: string | number;
  secondaryText: string;
  divider?: boolean;
}
const IconBox = (props: IIconBoxProps) => {
  const { iconName, primaryText, secondaryText, divider } = props;
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: pxToRem(15), md: pxTovW(15) },
          justifyContent: 'center',
          minWidth: { xs: pxToRem(110), md: 'auto' },
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
          }}
        >
          <IconWrapper
            name={iconName}
            size="md"
            parentFolder="icons"
            type="png"
            customSx={{
              height: { xs: pxToRem(15), lg: pxTovW(25) },
              width: { xs: pxToRem(15), lg: pxTovW(25) },
            }}
          />
          <Typography variant="h2" fontWeight="bold">
            {primaryText}
          </Typography>
        </Box>

        <Typography variant="h4" fontWeight="regular" sx={{ color: '#828282' }}>
          {secondaryText}
        </Typography>
      </Box>

      {divider && (
        <Divider
          orientation="vertical"
          sx={{
            width: '1px',
            // height: '100%',
            height: { xs: pxToRem(50), md: pxTovW(50) },
            backgroundColor: '#E0DFDE',
          }}
        />
      )}
    </>
  );
};

//=====================================================
